// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ufGC7","body":"styles_body__k4zwX","blueline":"styles_blueline__sd3X8","addButton":"styles_addButton__skhRf"};